// GCC Store Configuration
const gccStores = {
    SA: {
        domain: 'sa-store.myshopify.com',
        name: 'Saudi Arabia Store'
    },
    AE: {
        domain: 'uae-store.myshopify.com',
        name: 'UAE Store'
    },
    KW: {
        domain: 'kw-store.myshopify.com',
        name: 'Kuwait Store'
    },
    BH: {
        domain: 'bh-store.myshopify.com',
        name: 'Bahrain Store'
    },
    QA: {
        domain: 'qa-store.myshopify.com',
        name: 'Qatar Store'
    },
    OM: {
        domain: 'om-store.myshopify.com',
        name: 'Oman Store'
    },
     JO: {
        domain: 'jo.junaidperfumes.com',
        name: 'Jordan Store'
    }
};

// Function to check if user is from GCC
async function checkGCCVisitor() {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return ['SA', 'AE', 'KW', 'BH', 'QA', 'OM', 'JO'].includes(data.country_code);
  } catch (error) {
    console.error('Error checking location:', error);
    return false;
  }
}

// Function to handle popup display and redirection
async function handleGCCPopup() {
  const popup = document.getElementById('gccPopup');
  const redirectBtn = document.getElementById('gccRedirectBtn');
  const stayBtn = document.getElementById('gccStayBtn');
  
  // Check if user has already made a choice
  const hasChoice = localStorage.getItem('gccRedirectChoice');
  if (hasChoice) {
    return;
  }

  // Check if user is from GCC
  const isGCC = await checkGCCVisitor();
  if (!isGCC) {
    return;
  }

  // Get user's country and matching store
  const response = await fetch('https://ipapi.co/json/');
  const data = await response.json();
  const userCountry = data.country_code;
  const targetStore = window.gccStores[userCountry];
  const currentDomain = window.location.hostname;

  if (targetStore && currentDomain !== targetStore.domain) {
    // Show popup
    popup.style.display = 'block';
    
    // Handle redirect button click
    redirectBtn.addEventListener('click', () => {
      localStorage.setItem('gccRedirectChoice', 'redirected');
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      window.location.href = `https://${targetStore.domain}${currentPath}${currentSearch}`;
    });

    // Handle stay button click
    stayBtn.addEventListener('click', () => {
      localStorage.setItem('gccRedirectChoice', 'stayed');
      popup.style.display = 'none';
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', handleGCCPopup);

// Export for use in other scripts if needed
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { handleGCCPopup, gccStores };
}
